// TODO: Offload location strings to server

const HDA = {
	data: {
		event: null,
		page: null,
		user: {
			mobile: window.matchMedia("(any-pointer:coarse)").matches,
			agent: navigator.userAgent,
			language: navigator.language,
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			location: null,
		},
	},
	hasExit: false,
	init: function () {
		console.log("HDAnalyics init");

		HDA.location.init();

		HDA.data.event = "pageview";
		HDA.getPage();

		HDA.fetch();

		window.addEventListener("pagehide", (event) => {
			if (!HDA.isActive) {
				HDA.exit("pagehide");
			}
		});

		document.addEventListener("visibilitychange", () => {
			if (!HDA.isActive) {
				HDA.exit("visibilitychange");
			}
		});
	},
	exit: function (type) {
		if (hasExit) {
			return;
		}
		HDA.hasExit = true;
		HDA.data.event = "exit";

		if (navigator.sendBeacon) {
			navigator.sendBeacon(HDANALYTICS_URL, JSON.stringify(HDA.data));
			return;
		}

		HDA.fetch();
	},
	isActive: function () {
		return document.visibilityState && document.hasFocus();
	},
	isBotEnvironment: function () {
		return window._phantom || window.__nightmare || window.navigator.webdriver || window.Cypress;
	},
	getPage: function () {
		let load_time = 0;
		const navEntries = performance.getEntriesByType("navigation");

		if (navEntries.length > 0) {
			const navEntry = navEntries[navEntries.length - 1];
			load_time = navEntry.responseEnd - navEntry.startTime;
		}

		const urlParams = new URLSearchParams(window.location.search);
		let utmSource = urlParams.get("utm_source");
		if (utmSource === null) {
			utmSource = "";
		}
		HDA.data.page = {
			time: Date.now(),
			title: document.title,
			host: window.location.host,
			href: window.location.href,
			path: window.location.pathname,
			referrer: document.referrer,
			source: utmSource,
			performance: load_time,
			page_id: HDANALYTICS_ID,
		};
	},
	fetch: function (callback = false) {
		fetch(HDANALYTICS_URL, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, keepalive: !0, body: JSON.stringify(HDA.data) })
			.then(async function (e) {
				console.log(await e.json());
				if (callback) {
					callback(e);
				}
			})
			.catch(async function (e) {
				console.error("There was an error with " + callback);
			});
	},
	location: {
		init() {
			HDA.data.user.location = this.get();
		},
		get() {
			const tz = HDA.data.user.timezone;
			if (!tz || typeof tz !== "string") return "Other";

			// High-confidence
			if (this.isCanada(tz)) return "Canada";
			if (this.isUSA(tz)) return "USA";
			if (this.isMexico(tz)) return "Mexico";
			if (tz === "Asia/Kolkata") return "India";
			if (tz === "Asia/Shanghai") return "China";
			if (tz === "Asia/Tokyo") return "Japan";
			if (tz === "Asia/Seoul") return "South Korea";
			if (tz === "Asia/Manila") return "Philippines";
			if (tz === "Asia/Bangkok") return "Thailand";
			if (tz === "Asia/Ho_Chi_Minh") return "Vietnam";
			if (tz === "Europe/London") return "United Kingdom";
			if (tz === "Europe/Paris") return "France";
			if (tz === "Europe/Berlin") return "Germany";
			if (tz === "Europe/Rome") return "Italy";
			if (tz === "Europe/Madrid") return "Spain";
			if (tz === "Europe/Istanbul") return "Turkey";
			if (tz === "Europe/Stockholm") return "Sweden";
			if (tz === "Europe/Helsinki") return "Finland";
			if (tz === "Europe/Oslo") return "Norway";
			if (tz === "Europe/Copenhagen") return "Denmark";
			if (tz === "Atlantic/Reykjavik") return "Iceland";

			if (tz.startsWith("America/") && this.lists.brazil.has(tz)) return "Brazil";
			if (tz.startsWith("Europe/Moscow") || tz.startsWith("Asia/Yekaterinburg") || tz.startsWith("Asia/Novosibirsk") || tz.startsWith("Asia/Vladivostok")) return "Russia";

			// Continental
			if (tz.startsWith("Europe/")) return "Europe";
			if (tz.startsWith("Africa/")) return "Africa";
			if (tz.startsWith("Asia/")) return this.isMiddleEast(tz) ? "Middle East" : "Asia";
			if (tz.startsWith("Australia/")) return "Australia";
			if (tz.startsWith("Pacific/")) return "Oceania";
			if (tz.startsWith("Antarctica/")) return "Antarctica";

			// Americas fallback
			if (tz.startsWith("America/")) {
				if (this.isCaribbean(tz)) return "Caribbean";
				if (this.isCentralAmerica(tz)) return "Central America";
				return "South America";
			}

			return "Other";
		},
		isCanada(tz) {
			return this.lists.canada.has(tz);
		},
		isUSA(tz) {
			return this.lists.usa.has(tz);
		},
		isMexico(tz) {
			return tz.startsWith("America/Mexico_") || tz === "America/Tijuana" || tz === "America/Cancun";
		},
		isCentralAmerica(tz) {
			return this.lists.central_america.some((p) => tz.startsWith(p));
		},
		isCaribbean(tz) {
			return this.lists.caribbean.has(tz);
		},
		isMiddleEast(tz) {
			return this.lists.middle_east.has(tz);
		},
		lists: {
			canada: new Set(["America/Toronto", "America/Vancouver", "America/Montreal", "America/Edmonton", "America/Winnipeg", "America/Halifax", "America/St_Johns", "America/Regina", "America/Whitehorse", "America/Yellowknife", "America/Iqaluit"]),
			usa: new Set(["America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "America/Phoenix", "America/Anchorage", "America/Indiana/Indianapolis", "America/Detroit", "America/Boise", "America/Puerto_Rico"]),
			caribbean: new Set(["America/Havana", "America/Jamaica", "America/Barbados", "America/Santo_Domingo", "America/Puerto_Rico"]),
			central_america: ["America/Guatemala", "America/Costa_Rica", "America/Panama", "America/El_Salvador", "America/Managua", "America/Tegucigalpa"],
			middle_east: new Set(["Asia/Dubai", "Asia/Riyadh", "Asia/Jerusalem", "Asia/Baghdad", "Asia/Tehran", "Asia/Kuwait", "Asia/Qatar", "Asia/Bahrain"]),
			brazil: new Set(["America/Sao_Paulo", "America/Manaus", "America/Fortaleza", "America/Recife", "America/Belem"]),
		},
	},
};

window.addEventListener("load", function () {
	HDA.init();
});
